import { render } from "./recent-signatures.vue?vue&type=template&id=348eadd7"
import script from "./recent-signatures.vue?vue&type=script&lang=js"
export * from "./recent-signatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__